import { useSuspenseQuery } from "@tanstack/react-query";

import { useCompany } from "@/common/providers/company-provider";
import { invariant } from "@/common/utils/invariant";
import { combineCallingCodeWithCountry } from "@/common/utils/phone";
import { phoneCountryCodesQuery } from "@/routes/incomplete-user/incomplete-user.api";

const useCountryCode = (language: string) => {
  const {
    user: { phone },
  } = useCompany();
  const phoneCountryCodes = useSuspenseQuery(
    phoneCountryCodesQuery({ language }),
  );
  const currentCountryCode = phoneCountryCodes.data.find(
    (country) => country.phoneCountryCode === phone.countryCode,
  );
  // eslint-disable-next-line lingui/no-unlocalized-strings
  invariant(currentCountryCode, "current country code is expected");
  return {
    current: combineCallingCodeWithCountry(currentCountryCode),
    phoneCountryCodes,
  };
};

export { useCountryCode };
